(function () {

    'use strict';

    angular.module('app').controller('serviceProfileController', serviceProfileController);

    serviceProfileController.$inject = [
        'Units',
        '$scope',
        '$filter',
        '$rootScope',
        '$q',
        '$uibModal',
        'toastr',
        '$timeout',
        '$location',
        '$routeParams',
        'Carrier',
        'aborter',
        'ConfirmationModalFactory',
        'CarrierSettingsTableService',
        'Currency',
        'scrollToForm',
        'ViewChangeNotificationFactory',
        'ThresholdTableService',
        'ResellerListTable',
        'hasDuplicate',
        'isEqualsService',
        'isUniqueService',
        'CropperModalService',
        'ClientService',
        'PermissionHelpers',
        'AdminPermissionService'
    ];

    function serviceProfileController(
        Units,
        $scope,
        $filter,
        $rootScope,
        $q,
        $uibModal,
        toastr,
        $timeout,
        $location,
        $routeParams,
        Carrier,
        aborter,
        ConfirmationModalFactory,
        CarrierSettingsTableService,
        Currency,
        scrollToForm,
        ViewChangeNotificationFactory,
        ThresholdTableService,
        ResellerListTable,
        hasDuplicate,
        isEqualsService,
        isUniqueService,
        CropperModalService,
        ClientService,
        PermissionHelpers,
        AdminPermissionService
    ) {
        const sv = this;
        let CarrierSettingsTable = null;
        sv.params = $routeParams || {};
        sv.serviceProfileDimensions = { width: 1200, height: 1200 };
        sv.isViewMode = false;
        sv.id = sv.params.id === 'new' ? false : sv.params.id || false;
        sv.carrierProfileId = sv.params.carrierProfileId;
        sv.carrierprofileName = sv.params.carrierProfileName;
        sv.cloneService = cloneService;
        sv.save = saveOnly;
        sv.saveExit = saveExitProfile;
        sv.networkSharingChange = networkSharingChange;
        sv.onCarrierProfileSelect = onCarrierProfileSelect;
        sv.getCarrierProfiles = getCarrierProfiles;
        sv.invalidInput = invalidInput;
        sv.onServiceSelect = onServiceSelect;
        sv.goTo = goTo;
        sv.getPattern = getPattern;
        sv.currencies = [];
        sv.searchFuelLevies = searchFuelLevies;
        sv.profile = {};
        sv.isUnique = isUnique;
        sv.origServiceProfileName = undefined;
        sv.isTheSameCurrency = isTheSameCurrency;
        sv.changeServiceProfileStatus = changeServiceProfileStatus;
        sv.openCropper = openCropper;
        sv.updateProfileLogo = updateProfileLogo;
        sv.updateDisplayNames = updateDisplayNames;
        sv.updateDisplayNameInQuotes = updateDisplayNameInQuotes;
        sv.createMarginFrm = createMarginFrm;
        sv.getServiceProfiles = getServiceProfiles;

        sv.units = UNITS.combined;
        sv.defaultCurrency = $rootScope.GlobalProfile.office.currency;
        sv.defaultMeasureUnit = $rootScope.GlobalProfile.office.measureUnit;
        sv.defaultWeightUnit = $rootScope.GlobalProfile.office.weightUnit;
        sv.userCompanyId = $rootScope.GlobalProfile.company.id;

        sv.measureUnit = sv.units.find(unit => {
            return unit.values.weightUnit.toLowerCase() === sv.defaultWeightUnit.toLowerCase();
        });

        let viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });

        const cropperModal = new CropperModalService();
        const enableServiceSharing = new ConfirmationModalFactory({}, {
            message: 'messages.warning.enableServiceSharing.MESSAGE',
            code: 'messages.warning.enableServiceSharing.CODE',
        });

        const disableServiceSharing = new ConfirmationModalFactory({}, {
            message: 'messages.warning.disableServiceSharing.MESSAGE',
            code: 'messages.warning.disableServiceSharing.CODE',
        });

        const disableServiceProfile = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_SERVICE_PROFILE_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const enableServiceProfile = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_SERVICE_PROFILE_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        let unsaveForm = new ConfirmationModalFactory({}, {
            message: 'There are still unsaved data. These changes wont be saved.',
            code: 'Do you wish to continue?',
        });

        let getCurrencies = $q((resolve, reject) => {
            Currency.getList((data) => resolve(data), (error) => reject(error));
        });
        sv.networkSwitch = {
            true: $filter('translate')('labels.switch.ENABLE'),
            false: $filter('translate')('labels.switch.DISABLE'),
        };
        sv.autoReconcileSwitch = {
            true: $filter('translate')('labels.switch.ENABLE'),
            false: $filter('translate')('labels.switch.DISABLE'),
        }
        let serviceProfileSettings = null;

        const onRouteChange = $scope.$on('$routeChangeStart', function (event, next) {
            if (!sv.isViewMode && isDataTouched()) {
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        onRouteChange();
                        let nextRoute = next.$$route.originalPath;
                        if (_.contains(next.$$route.originalPath, ':')) {
                            nextRoute = nextRoute.split(':')[0];
                        }
                        $location.path(nextRoute);
                    }
                });
                event.preventDefault();
            }
        });

        init();
        function init() {
            sv.isFetching = true;
            initCarriers().then(data => {
                initCarrierProfiles();
                initProfile();
            });
        }

        function cloneService() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/pages/services/add-ons/cloneModal.html',
                controller: function ($uibModalInstance) {
                    var cm = this;
                    cm.saveClone = saveClone;
                    cm.dismiss = dismiss;
                    cm.name = 'CLONE - ' + angular.getObjVal(sv, 'profile.name');
                    cm.isCloneUnique = isCloneUnique;

                    function dismiss() {
                        $uibModalInstance.dismiss();
                    }

                    function isCloneUnique(model) {
                        cm.checkingDups = true;
                        aborter(() => {
                            hasDuplicate({
                                serviceCallback: Carrier.getServiceProfiles,
                                callbackFormat: ['success', 'error', 'filter'],
                                findBy: 'content',
                                compareWith: model,
                                compareBy: 'name',
                                raw: angular.getObjVal(sv, 'carrierRaw.name'),
                                filters: {
                                    size: 1,
                                    name: model
                                }
                            }).then(res => {
                                if (res)
                                    cm.hasDuplicateName = 'Service profile name is already taken';
                                else
                                    cm.hasDuplicateName = null;
                                cm.checkingDups = false;
                            }).catch(err => {
                                cm.checkingDups = false;
                            });
                        }, 500);
                    }

                    function saveClone(form) {
                        form.$setSubmitted();
                        if (form.$invalid)
                            return;
                        cm.fetching = true;
                        let payload = {
                            id: sv.id,
                            name: cm.name
                        };
                        cloneServiceProfile(payload).then((data) => {
                            cm.fetching = false;
                            $uibModalInstance.dismiss();
                            toastr.success('Service profile cloned');
                            $location.path('/carriers/service-profiles/' + data.id);
                        }).catch(() => {
                            cm.fetching = false
                        });
                    }

                    (() => {
                        isCloneUnique(cm.name);
                    })()
                },
                controllerAs: 'cm',
                size: 'md',
                appendTo: $('body')
            });
        }

        function showShareMarginsModal(data) {

            const modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/modal/share-margins-modal.html',
                controller: 'ShareMarginsModalController',
                controllerAs: 'vm',
                size: 'md',
                appendTo: $('body'),
                resolve: {
                    totalServiceProfiles: function () {
                        return sv.totalResellers;
                    },
                    serviceProfileName: function () {
                        return sv.profile.name;
                    },
                    data: function () {
                        return data;
                    },
                    serviceProfileId: function () {
                        return sv.id;
                    },
                    networkEffects: function () {
                        return sv.profile.networkEffects;
                    }
                }
            });

            modalInstance.result.then(function (data) {
                sv.resellers = data;
                sv.profile.networkEffects = data;
                updateServiceProfile();
            });
        }

        function saveProfile(...forms) {
            const defer = $q.defer();
            CarrierSettingsTable.setSubmitted();
            const validForms = forms.every((form) => {
                form.$setSubmitted();
                if (form.$valid)
                    return true;
                scrollToForm(form.$name);
                return false;
            }) && CarrierSettingsTable.isValid;
            if (!validForms) return defer.promise;

            if (sv.id) {
                const selectedReSellers = getSelectedNetworkEffectResellers();
                if (selectedReSellers.length > 0) {
                    if (!sv.profile.marginEnabled) {
                        toastr.error("No margins", "Error");
                        return;
                    }
                    showShareMarginsModal(selectedReSellers);
                } else {
                    updateServiceProfile();
                }
            } else {
                createNewServiceProfile(cleanPayload(sv.profile)).then((data) => {
                    defer.resolve(data);
                }).catch(err => {
                    sv.savingData = false;
                    defer.reject(err);
                });
            }
            return defer.promise;
        }

        function getTotalNetworkEffectResellers() {
            ClientService.Reseller.getAll(data => {
                sv.totalResellers = data.totalElements;
            }, error => {
                console.log(error);
            }, {
                size: 20,
                enabled: true,
                sort: 'id,desc'
            });
        }

        function getSelectedNetworkEffectResellers() {
            return sv.resellerListTableInstance.getSelectedRows();
        }

        function updateServiceProfile() {
            const defer = $q.defer();
            sv.savingData = true;
            Carrier.updateServiceProfile(sv.id, (data) => {
                sv.profileRaw = angular.copy(sv.profile);
                toastr.success('Service profile has been updated');
                defer.resolve(data);
                sv.savingData = false;
            }, (error) => {
                toastr.error('Unable to update profile', error);
                sv.savingData = false;
                defer.reject(error);
                sv.savingData = false;
            }, cleanPayload(sv.profile));
        }

        function createNewServiceProfile(payload) {
            const defer = $q.defer();
            Carrier.createServiceProfile((data) => {
                toastr.success('Service profile has been created');
                defer.resolve(data);
            }, (error) => {
                toastr.error(error.message, 'Unable to save profile');
                defer.reject(error);
            }, payload);
            return defer.promise;
        }

        function cloneServiceProfile(payload) {
            const defer = $q.defer();
            Carrier.cloneServiceProfile((data) => {
                defer.resolve(data);
            }, (error) => {
                toastr.error('Unable to save profile', error);
                defer.reject(error);
            }, payload);
            return defer.promise;
        }

        function checkIncompleteTableForms(tableData) {
            const incomplete = tableData.filter(data => {
                if (data.editMode) {
                    data.isSelected = true;
                    return true;
                }
                return false;
            });
            return incomplete;
        }

        function saveOnly(...forms) {
            let openWeightThresholdFrm = checkIncompleteTableForms(sv.weightThresholdTable.data);
            let openDimensionThresholdFrm = checkIncompleteTableForms(sv.dimensionThresholdTable.data);

            if (openDimensionThresholdFrm.length === 0 && openWeightThresholdFrm.length === 0) {
                saveStart();
            } else {
                unsaveForm.getInstance().result.then(function (cond) {
                    if (cond) {
                        sv.weightThresholdTable.data = sv.weightThresholdTable.data.filter(val => {
                            if (!val.isNew) {
                                val.editMode = false;
                                return val;
                            }
                        });

                        sv.dimensionThresholdTable.data = sv.dimensionThresholdTable.data.filter(val => {
                            if (!val.isNew) {
                                val.editMode = false;
                                return val;
                            }
                        });
                        saveStart();
                    }
                });
            }

            function saveStart() {
                const fuelLevyEnabled = angular.getObjVal(sv.profile, 'fuelLevy.enabled');
                
                if (fuelLevyEnabled) {
                    let fuelLevyCurrency = (sv.profile.fuelLevy.details.currency !== null) ? sv.profile.fuelLevy.details.currency : 'AUD';
                    let currentCurrency = sv.profile.currencyObj.currencyCode;

                    if (fuelLevyCurrency === currentCurrency) {
                        saveProfile(...forms).then(data => {
                            sv.uploadingServiceProfileLogo = true;
                            uploadLogo(sv.serviceProfileLogo, data.id).then(() => {
                                onRouteChange();
                                sv.uploadingServiceProfileLogo = false;
                                $location.path('/carriers/service-profiles/' + data.id)
                            });
                        });
                    } else {
                        let params = {
                            val1: fuelLevyCurrency,
                            val2: currentCurrency,
                            errorMsg: `Selected Fuel Levy currency is not equal with the service profile currency. Please consider
                                    selecting another one from the list.`,
                            formField: forms[2].fuelLevy
                        };
                        isEqualsService.isEquals(params);
                    }
                } else {
                    if(forms[2] !== undefined){
                         forms[2].fuelLevy.$setValidity('isEquals', true);
                    }
                    forms = forms.filter(form => form !== undefined);
                
                    saveProfile(...forms).then(data => {
                        uploadLogo(sv.serviceProfileLogo, data.id).then(() => {
                            onRouteChange();
                            $location.path('/carriers/service-profiles/' + data.id);
                        });
                    });
                }
            }
        }

        function saveExitProfile(...forms) {
            saveProfile(...forms).then(() => {
                $location.path('/carriers/service-profiles');
            });
        }

        function isDataTouched() {
            return !angular.equals(cleanPayload(sv.profile), cleanPayload(sv.profileRaw))
                || !angular.equals(sv.profileRaw.settings, CarrierSettingsTable.getSettingsPayload());
        }

        function searchFuelLevies(select) {
            if (select.open) {
                sv.searching = true;
                let fuelLevies = [];
                sv.fuelLevies = [];
                getFuelLevyByService(select).then(data => {
                    fuelLevies.push(...data);
                    sv.fuelLevies = fuelLevies
                    sv.searching = false;
                    // sv.fuelLevies.push(...fuelLevies);
                    // console.log(sv.fuelLevies)
                    // getFuelLevyByCarrier(select).then(data=>{
                    //     fuelLevies.push(...data);
                    //     getPublicFuelLevies(select).then(data=>{
                    //         fuelLevies.push(...data);
                    //         sv.fuelLevies.push(...fuelLevies);
                    //         sv.searching = false;
                    //     })
                    // })
                });
            }
        }

        function getFuelLevyByService(select) {
            const defer = $q.defer();

            Carrier.getFuelLevies(data => {
                // let filteredData = $filter("theSameCurrency")(data.content, sv.profile.currency);
                // console.log(data)
                defer.resolve(data.content);
            }, error => {
                defer.resolve([]);
                toast.error('Unable to fetch Fuel Levies', error.message);
            }, {
                name: select.search,
                carrierId: angular.getObjVal(sv, 'profile.carrierObj.id'),
                serviceId: angular.getObjVal(sv, 'profile.serviceObj.id')
            });
            return defer.promise;
        }

        function getFuelLevyByCarrier(select) {
            const defer = $q.defer();
            if (!angular.getObjVal(sv, 'profile.carrierObj.id')) {
                $timeout(() => {
                    defer.resolve([]);
                });
                return defer.promise;
            }
            Carrier.getFuelLevies(data => {
                let filteredData = $filter("theSameCurrency")(data.content, sv.profile.currency);
                defer.resolve(filteredData);
            }, error => {
                defer.resolve([]);
                toast.error('Unable to fetch Fuel Levies', error.message);
            }, {
                name: select.search,
                carrierId: angular.getObjVal(sv, 'profile.carrierObj.id'),
                serviceId: null
            });

            return defer.promise;
        }

        function getPublicFuelLevies(select) {
            const defer = $q.defer();
            Carrier.getFuelLevies(data => {
                let filteredData = $filter("theSameCurrency")(data.content, sv.profile.currency);
                defer.resolve(filteredData);
            }, error => {
                defer.resolve([]);
                toast.error('Unable to fetch Fuel Levies', error.message);
            }, {
                name: select.search,
                carrierId: null
            });
            return defer.promise;
        }

        function networkSharingChange(event) {
            event.preventDefault();
            $timeout(() => {
                if (sv.profile.networkEffectEnabled) {
                    sv.profile.networkEffectEnabled = false;
                    enableServiceSharing.getInstance().result.then(function (cond) {
                        if (cond) {
                            sv.profile.networkEffectEnabled = true;
                        }
                    });
                } else {
                    sv.profile.networkEffectEnabled = true;
                    disableServiceSharing.getInstance().result.then(function (cond) {
                        if (cond) {
                            sv.profile.networkEffectEnabled = false;
                        }
                    });
                }
            });
        }

        function onCarrierProfileSelect(carrierProfile) {
            sv.serviceProfiles = [];
            sv.profile.carrierProfileId = carrierProfile.id;
            sv.profile.serviceObj = null;
            sv.profile.carrierObj = sv.carriers.find((carrier) => carrier.id === angular.getObjVal(carrierProfile, 'carrierId'));

            sv.services = sv.profile.carrierObj.services;
            sv.isUnique(sv.profile.name, sv.serviceProfileForm.serviceProfileName, sv.origServiceProfileName, 'name');
        }

        function invalidInput(form, input) {
            return (form.$submitted && angular.getObjVal(form, input + '.$invalid') ||
                angular.getObjVal(form, input + '.$invalid') && angular.getObjVal(form, input + '.$touched'));
        }

        function cleanPayload(profile) {
            return {
                cubicConversionFactor: profile.cubicConversionFactor,
                carrierAccountCode: profile.carrierAccountCode ? profile.carrierAccountCode : null,
                carrierProfileId: profile.carrierProfileId ? profile.carrierProfileId : null || profile.carrierProfileObj.id,
                name: profile.name ? profile.name : null,
                serviceName: profile.serviceName || null,
                settings: CarrierSettingsTable.getSettingsPayload(),
                serviceId: profile.serviceId ? profile.serviceId : null,
                active: !!profile.active,
                insuranceAmount: profile.insuranceAmount,
                displayName: profile.displayName,
                shopifyQuoteOverride: profile.shopifyQuoteOverride,
                chargeDeadWeight: profile.chargeDeadWeight,
                fuelLevy: {
                    enabled: angular.getObjVal(profile, 'fuelLevy.enabled'),
                    id: angular.getObjVal(profile, 'fuelLevy.details.id') ? angular.getObjVal(profile, 'fuelLevy.details.id') : null
                },
                networkEffectEnabled: profile.networkEffectEnabled,
                networkEffects: profile.networkEffects,
                enabledPalletizingInstructions:profile.enabledPalletizingInstructions,
                currency: profile.currency,
                accountingSetting: {
                    autoReconcile: angular.getObjVal(profile, 'accountingSetting.autoReconcile') ? profile.accountingSetting.autoReconcile : false
                }
            };
        }

        function goTo(url, params) {
            $location.path(url).search(params);
        }

        function setIsHideRatesEngine() {
            AdminPermissionService.AdminCurrentUser.getAdminUserDetails(success => {
                const moduleAccess = [];
                success.content.forEach(user => {
                    user.modules.forEach(module => {
                        moduleAccess.push(module.name);
                    });
                });
                sv.isHideRatesEngine = PermissionHelpers.isHideRatesEngine(moduleAccess);
            }, error => { }, $rootScope.GlobalProfile.id);
        }

        function initProfile() {
            getTotalNetworkEffectResellers();
            setIsHideRatesEngine();
            
            if (sv.id) {
                Carrier.getServiceProfile(sv.id, (data) => {
                    if (data.detailHidden) {
                        toastr.error('Service profile details don\'t exist');
                        $location.path('/carriers/service-profiles');
                        return false;
                    }
                    sv.isReceiver = !data.owned;
                    sv.isFetching = false;
                    sv.profile = data;
                    sv.profileRaw = angular.copy(data);
                    sv.origServiceProfileName = angular.copy(data.name);
                    initCarrierProfile(sv.carrierProfiles, angular.getObjVal(data, 'carrierProfile.id'));
                    if (sv.profile.carrierObj)
                        initService(sv.profile.carrierObj, angular.getObjVal(data, 'service.id'));
                    initThresholdTable();
                    buildCarrierNetworkTable();
                    initCurrency(sv.profile).then(() => {
                        buildCarrierSettingsTable(getMappedSettings(angular.getObjVal(sv, 'profile.service.settings'), sv.profile.settings));
                        $timeout(() => sv.profileRaw = angular.copy(sv.profile));
                    });

                    setIsNetworkEffectProfile();
                    setIsViewMode();
                }, (error) => {
                    toastr.error('Service profile details don\'t exist', error.message);
                    $location.path('/carriers/service-profiles');
                    return false;
                });
            } else {
                sv.profile = { settings: [] };
                sv.isFetching = false;
                initCarrierProfile(sv.carrierProfiles, sv.carrierProfileId);
                initThresholdTable();
                buildCarrierNetworkTable();
                initCurrency(sv.profile).then(() => {
                    buildCarrierSettingsTable([]);
                    $timeout(() => sv.profileRaw = angular.copy(sv.profile));
                });
                findCarrierprofile();
                sv.profile.owned = true
            }
        }

        function setIsNetworkEffectProfile() {
            sv.isNetworkEffectProfile = sv.profile.networkEffects.length > 0;
        }

        function setIsViewMode() {
            sv.isViewMode = !sv.profile.owned;
        }

        function buildCarrierNetworkTable() {
            sv.resellerListTableInstance = new ResellerListTable(sv.profile.networkEffects);
            sv.resellerListTable = sv.resellerListTableInstance.tableData;
        }

        function initThresholdTable() {
            sv.weightThresholdTable = new ThresholdTableService(angular.extend(sv.profile, {
                thresholdForm: sv.weightThresholdForm
            }), {
                readOnly: isReadOnly(),
                path: 'weight',
                measureUnit: $rootScope.GlobalProfile.office.measureUnit,
                weightUnit: $rootScope.GlobalProfile.office.weightUnit
            }).tableData;

            sv.dimensionThresholdTable = new ThresholdTableService(angular.extend(sv.profile, {
                thresholdForm: sv.dimensionThresholdForm
            }), {
                readOnly: isReadOnly(),
                path: 'dimension',
                measureUnit: $rootScope.GlobalProfile.office.measureUnit,
                weightUnit: $rootScope.GlobalProfile.office.weightUnit
            }).tableData;

            sv.distanceThresholdTable = new ThresholdTableService(angular.extend(sv.profile, {
                thresholdForm: sv.distanceThresholdForm
            }), {
                readOnly: isReadOnly(),
                path: 'distance',
                measureUnit: $rootScope.GlobalProfile.office.measureUnit,
                weightUnit: $rootScope.GlobalProfile.office.weightUnit
            }).tableData;

            sv.itemPackageThresholdTable = new ThresholdTableService(angular.extend(sv.profile, {
                thresholdForm: sv.itemPackageThresholdForm
            }), {
                readOnly: isReadOnly(),
                path: 'item',
                measureUnit: $rootScope.GlobalProfile.office.measureUnit,
                weightUnit: $rootScope.GlobalProfile.office.weightUnit
            }).tableData;

            sv.manualHandlingThresholdTable = new ThresholdTableService(angular.extend(sv.profile, {
                thresholdForm: sv.manualHandlingThresholdForm,
            }), {
                readOnly: isReadOnly(),
                path: 'manual-handling',
                measureUnit: $rootScope.GlobalProfile.office.measureUnit,
                weightUnit: $rootScope.GlobalProfile.office.weightUnit,
                currency: $rootScope.GlobalProfile.office.currency
            }).tableData;

            sv.oversizeThresholdTable = new ThresholdTableService(angular.extend(sv.profile, {
                thresholdForm: sv.oversizeThreshold
            }), {
                readOnly: isReadOnly(),
                path: 'oversize',
                measureUnit: $rootScope.GlobalProfile.office.measureUnit,
                weightUnit: $rootScope.GlobalProfile.office.weightUnit,
                currency: $rootScope.GlobalProfile.office.currency
            }).tableData;
        }

        function isReadOnly() {
            return !sv.profile.owned;
        }

        function initCurrency(profile) {
            const defer = $q.defer();
            getCurrencies.then((currencies) => {
                sv.profile.currencyObj = currencies.find((currency) => {
                    return currency.currencyCode === profile.currency;
                });
                if (!sv.profile.currencyObj) {
                    sv.profile.currencyObj = currencies.find(currency => {
                        return currency.currencyCode.toLowerCase() === sv.defaultCurrency.toLowerCase();
                    });
                    profile.currency = sv.profile.currencyObj.currencyCode;
                }
                sv.currencies = currencies;
                defer.resolve();
            }).catch(() => {
                defer.reject();
            });
            return defer.promise;
        }

        function initCarrierProfile() {

            sv.profile.carrierProfileObj = sv.profile.carrierProfile;
            if (sv.profile.carrierProfileObj) {
                onCarrierProfileSelect(sv.profile.carrierProfileObj);
            }
            angular.extend(sv.profile, {
                networkEffect: sv.profile.networkEffect || {
                    resellers: []
                }
            });
        }

        function findCarrierprofile() {
            initCarrierProfiles({ name: sv.carrierprofileName }).then(() => {
                if (!sv.carrierProfiles) { return; }
                sv.profile.carrierProfileObj = sv.carrierProfiles.find(carrier => carrier.id === sv.carrierProfileId);
                sv.profile.carrierObj = sv.carriers.find((carrier) => carrier.id === angular.getObjVal(sv.profile.carrierProfileObj, 'carrierId'));
                console.log(sv.profile.carrierObj)
                sv.services = sv.profile.carrierObj.services;
            });
        }

        function initService(carrier, serviceId) {
            sv.profile.serviceObj = carrier.services.find((service) => service.id === serviceId);
            if (sv.profile.serviceObj)
                sv.profile.serviceId = sv.profile.serviceObj.id;
            angular.extend(sv.profile, {
                networkEffect: sv.profile.networkEffect || {
                    resellers: []
                }
            });
        }

        function initCarrierProfiles(data) {
            const defer = $q.defer();
            getCarrierProfiles(data).then((response) => {
                sv.carrierProfiles = angular.copy(response.content);
                defer.resolve(response);
            }).catch(error => {
                defer.reject(error);
                toastr.error('Unable to fetch carriers', error);
            });
            return defer.promise;
        }

        function getCarrierProfiles(data) {
            const defer = $q.defer();
            Carrier.carrierProfilesCompact((data) => {
                sv.carrierProfiles = data.content;
                defer.resolve(data);
            }, (error) => {
                defer.reject(error);
                toastr.error('Unable to fetch carriers', error);
            }, angular.extend({ size: 10 }, data));
            return defer.promise;
        }

        function getServiceProfiles(data) {
            const defer = $q.defer();
            const filter = angular.extend({ size: 10 }, data);

            if (angular.getObjVal(sv.profile, 'carrierProfileObj.carrierId')) {
                filter.carrierId = sv.profile.carrierProfileObj.carrierId;
            }

            sv.loadingServiceProfiles = true;
            sv.serviceProfiles = [];
            Carrier.serviceProfilesCompact(data => {
                sv.loadingServiceProfiles = true;
                sv.serviceProfiles = data.content;
                defer.resolve(data);
            }, error => {
                sv.loadingServiceProfiles = true;
                defer.reject(error);
                toastr.error('Unable to fetch service profiles', error);
            }, filter);
            return defer.promise;
        }

        function initCarriers() {
            const defer = $q.defer();

            Carrier.getCarriers((data) => {
                sv.carriers = data;
                defer.resolve(data);
            }, (error) => {
                defer.reject(error);
                toastr.error('Unable to fetch carriers', error);
            });

            return defer.promise;
        }

        function getMappedSettings(carrierSettings, profileSettings) {
            let options = [];
            angular.forEach(carrierSettings, carrierSetting => {
                const matchSetting = profileSettings ? profileSettings.find(profileSetting => profileSetting.name === carrierSetting.name) : null;
                options.push({
                    name: matchSetting ? matchSetting.name : carrierSetting.name,
                    description: matchSetting ? matchSetting.description : carrierSetting.description,
                    value: matchSetting ? matchSetting.value : carrierSetting.value,
                    valueList: matchSetting ? matchSetting.valueList : null,
                    valueType: matchSetting ? matchSetting.valueType : null,
                    mandatory: carrierSetting.mandatory,
                    prerequisiteSettings: carrierSetting.prerequisiteSettings,
                    options: carrierSetting && carrierSetting.option ? {
                        true: angular.getObjVal(carrierSetting, 'option.vtrue'),
                        false: angular.getObjVal(carrierSetting, 'option.vfalse')
                    } : null
                });
            });
            return options;
        }

        function onServiceSelect(service) {
            sv.profile.fuelLevy =
            {
                enabled: angular.getObjVal(sv, 'profile.fuelLevy.enabled'),
                details: {}
            };
            sv.profile.serviceId = service.id;
            buildCarrierSettingsTable(getMappedSettings(service.settings, sv.profile.settings));
        }

        function buildCarrierSettingsTable(serviceProfileSettings) {
            sv.settingsTable = null;
            $timeout(() => {
                CarrierSettingsTable = new CarrierSettingsTableService(serviceProfileSettings);
                sv.settingsTable = CarrierSettingsTable.buildSettings();
                sv.profile.settings = CarrierSettingsTable.getSettingsPayload();
            });
        }

        function getPattern() {
            if (!angular.getObjVal(sv, 'profile.fuelLevy.active')) {
                return sv.unitRegex = '^(?=.*[0-9])\\d{0,15}(?:\\.\\d*)?$';
            }
            return sv.unitRegex = '^(?=.*[1-9])\\d{0,15}(?:\\.\\d*)?$';
        }

        function isUnique(model, formField, origVal, prop) {
            let params = {};
            params.model = model;
            params.origName = origVal;
            params.formField = formField;
            params.service = Carrier;
            params.serviceMethod = "getServiceProfiles";
            params.property = prop;
            params.warningMsg = `${prop} is already taken`;
            params.filter = {
                carrierProfileId: sv.profile.carrierProfileObj && sv.profile.carrierProfileObj.id || sv.profile.carrierProfileId || undefined
            };
            isUniqueService.isUnique(params);
        }

        function isTheSameCurrency(model, formField) {
            $timeout(() => {
                if (model) {
                    if (sv.profile.fuelLevy.enabled) {
                        let selectedCurrency = (model.currency === null && sv.profile.currency === 'AUD') ? 'AUD' : model.currency;
                        let serviceProfileCurrency = sv.profile.currency;
                        let params = {
                            val1: selectedCurrency,
                            val2: serviceProfileCurrency,
                            errorMsg: 'Selected fuel levy currency is not equal with the selected service profile currency.',
                            formField: formField
                        };
                        let valid = isEqualsService.isEquals(params);
                        sv.currencyTooltip = !valid ? params.errorMsg : false;
                    } else {
                        formField.$setValidity('isEquals', true);
                        sv.currencyTooltip = false;
                    }
                }
            }, 100);
        }

        function changeServiceProfileStatus(event) {
            event.preventDefault();
            $timeout(() => {
                if (sv.profile.active) {
                    sv.profile.active = false;
                    enableServiceProfile.getInstance().result.then(cond => {
                        if (cond) {
                            sv.profile.active = true;
                        }
                    });

                } else {
                    sv.profile.active = true;
                    disableServiceProfile.getInstance().result.then(cond => {
                        if (cond) {
                            sv.profile.active = false;
                        }
                    });
                }
            });
        }

        function uploadLogo(file, id) {
            const defer = $q.defer();
            Carrier.uploadServiceProfileLogo(file, id, () => {
                toastr.success('Logo successfully updated');
                defer.resolve();
            }, error => {
                toastr.error(error.message);
                defer.reject();
            });
            return defer.promise;
        }

        function openCropper(load, fieldName) {
            cropperModal.setImageFile(load);
            cropperModal.getInstance().result.then(newImage => {
                sv[fieldName] = cropperModal.dataURItoBlob(newImage, load.$ngfName);
            });
        }

        function updateProfileLogo() {
            sv.isUploadingLogo = true;
            if (!sv.serviceProfileLogo) {
                sv.isUploadingLogo = false;
                return;
            }

            uploadLogo(sv.serviceProfileLogo, sv.id).then(() => {
                sv.isUploadingLogo = false;
                onRouteChange();
                $location.path('/carriers/service-profiles/' + data.id);
            });
        }

        function updateDisplayNameInQuotes() {
            sv.isUpdatingDisplayName = true;
            sv.profileRaw.displayName = sv.profile.displayName;

            Carrier.updateServiceProfile(sv.id, (data) => {
                sv.isUpdatingDisplayName = false;
                toastr.success('Service profile display name has been updated');
            }, (error) => {
                toastr.error('Unable to update service profile display name', error);
                sv.isUpdatingDisplayName = false;
            }, cleanPayload(sv.profileRaw));
        }

        function createMarginFrm() {
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'full-height-modal',
                templateUrl: '/templates/pages/services/modal/create-margin-modal.html',
                controller: 'CreateMarginModalController',
                controllerAs: 'vm',
                size: 'md',
                appendTo: $('body'),
                resolve: {
                    serviceProfileIds: () => {
                        return [sv.profile]
                    }
                }
            });
            modalInstance.result.then(function (data) {
            }, function () {
            });
        }

        function updateDisplayNames() {
            sv.updatingNames = true;
            const payload = {
                displayName: sv.profile.displayName,
                serviceName: sv.profile.serviceName,
                shopifyQuoteOverride: sv.profile.shopifyQuoteOverride
            };

            Carrier.updateServiceProfileNames(sv.id, (data) => {
                sv.updatingNames = false;
                toastr.success('Names successfully updated!', 'Success');
            }, error => {
                sv.updatingNames = false;
                toastr.error(error.message, 'Error');
            }, payload);
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/serviceProfileController.js